import { render, staticRenderFns } from "./OverlayHeader.vue?vue&type=template&id=33f95df1&scoped=true"
import script from "./OverlayHeader.vue?vue&type=script&lang=js"
export * from "./OverlayHeader.vue?vue&type=script&lang=js"
import style0 from "./OverlayHeader.vue?vue&type=style&index=0&id=33f95df1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f95df1",
  null
  
)

export default component.exports